module.exports = __webpack_public_path__ + "media/background0.2e38c9e3.webm";